import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { useState, useEffect, useRef, useMemo } from 'preact/hooks'
import { defaultConfig, sortOptions } from '../config'

import Sidebar from './Sidebar'
import SidebarMobile from './SidebarMobile'
import FilterAndSort from './FilterAndSort'
import ResaleButtons from './ResaleButtons'

export default ({ mobile, cardWidth }) => {
    const { loading, query, response, pageType } = useAppState()
    const { updateSearch } = useActions()

    const [openSort, setOpenSort] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);

    const isMobile = window.innerWidth < 769;

    const [selectedTwo, setSelectedTwo] = useState(false);
    const [selectedThree, setSelectedThree] = useState(false);

    useEffect(() => {
        if (isMobile) {
            setSelectedTwo(true)
            setSelectedThree(false)
        } else {
            setSelectedThree(true)
            setSelectedTwo(false)
        }
    }, [])

    const handleClickOpenSort = () => {
        setOpenSort(true)
    }

    const handleClickOpenFilter = () => {
        setOpenFilter(true)
    }

    const handleClickCloseSort = () => {
        setOpenSort(false)
    }

    const handleClickCloseFilter = () => {
        setOpenFilter(false)
    }

    const addToSegment = () => {
        nostojs(function (api) { api.addSegmentCodeToVisit("three-across-mobile") })
    }

    const docCount = response.products?.total ?? 0

    /* ---------- test for shoppable novel app, HK store only ---------- */
    const isHkSite = useMemo(() => (window.Shopify?.country === 'HK' || window.Shopify?.store === 'dvf-hongkong.myshopify.com'), [])
    const novelShopRef = useRef(null);
    const toolbarRef = useRef(null);
    
    useEffect(() => {
        const novelShopSection = document.getElementById('shopify-section-novel-shoppable-video-plp');
        if(isHkSite && !novelShopRef?.current && novelShopSection) {
            novelShopSection.remove();
            novelShopRef.current = novelShopSection;
        }
    }, []);

    useEffect(() => {
        if(isHkSite && toolbarRef?.current && novelShopRef.current) {
            toolbarRef.current.insertBefore(novelShopRef.current, toolbarRef.current.firstChild);
        }
    }, [ novelShopRef.current ])
    /* ------------------------------ end test ------------------------------ */

    /* ------------------------------ Shopify Broadcast theme subcollections section ------------------------------ */
    const [subCollections, setSubCollections] = useState(null);
    useEffect(() => {
        const el = document.querySelector('nosto-collection');
        const nostoSubCollections = el?.dataset?.nostoCollection && JSON.parse(el?.dataset?.nostoCollection);
        if (nostoSubCollections) setSubCollections(nostoSubCollections);
    }, []);
    /* ------------------------------ Shopify Broadcast theme subcollections section ------------------------------ */

    return (
        <div
            class='ns-header-controls align-center justify-between' ref={toolbarRef}>
            
            {pageType == "category" && <div class="ns-sub-collections ns-d-flex ns-gap-4 ns-align-items-baseline">
                { subCollections && Object.keys(subCollections).map(key => (
                        <div>
                            <a class="subcollection__link relative" href={subCollections[key]?.uri}>
                                <div class="subcollection__text">
                                    <p className={`subcollection__title h4 ${subCollections[key]?.current ? "ns-font-bold" : ""}`} style={{ whiteSpace: 'nowrap' }}>{key}</p>
                                </div>
                            </a>
                        </div>
                    ))      
                }
            </div>}
                {pageType == "search" && <ResaleButtons />}
            <div
                class='ns-header-filter'>
                <div class="ns-product-count">{ docCount } items</div>
                <div class="ns-toolbar-item">
                    <span class="ns-filters ns-text-underline" onClick={handleClickOpenFilter}>Filter &amp; Sort</span>
                    <FilterAndSort
                        openFilter={openFilter}
                        openSort={openSort}
                        setOpenFilter={setOpenFilter}
                        setOpenSort={setOpenSort}
                    />
                </div>
            </div>
        </div>
    )
}
